import React from "react";
import { Leaf, Recycle, Users, Droplet, Sun } from "lucide-react";
import PageHero from "../components/blocks/PageHero";
import Section from "../components/ui/Section";
import useSEO from "../hooks/useSEO";

const Card = ({ icon: Icon, title, desc }) => (
  <div className="rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-md">
    <div className="rounded-2xl border border-white/10 bg-black/25 p-3 w-fit">
      <Icon size={22} className="text-white/80" />
    </div>
    <div className="mt-5 text-lg font-semibold text-white">{title}</div>
    <p className="mt-2 text-sm text-white/70 leading-relaxed">{desc}</p>
  </div>
);

const Sustainability = () => {
  useSEO('/sustainability');
  
  return (
    <div className="min-h-screen bg-[#050706] text-[#F4F1E8] pt-16">
      <PageHero
        title="Sustainability & Community"
        subtitle="Hospitality in harmony with nature"
        image="https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=2400&q=80"
      />

      <Section className="py-16">
        <h2 className="text-3xl md:text-4xl font-light text-white">
          Concrete actions, everyday
        </h2>
        <p className="mt-4 max-w-3xl text-sm md:text-base text-white/70 leading-relaxed">
          Sustainability isn’t a marketing line for us — it’s the foundation. We aim to protect the
          ecosystem and support the local community that makes Moonrise Valley what it is.
        </p>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          <Card
            icon={Leaf}
            title="Zero-deforestation mindset"
            desc="Built around trees and natural contours wherever possible — with minimal disturbance."
          />
          <Card
            icon={Droplet}
            title="Water care"
            desc="Water is precious in the forest. We keep usage mindful and encourage responsible habits."
          />
          <Card
            icon={Recycle}
            title="Low-plastic operations"
            desc="We actively reduce single-use plastics and choose reusable alternatives."
          />
          <Card
            icon={Sun}
            title="Energy awareness"
            desc="Efficient lighting and mindful consumption—quiet comfort without waste."
          />
          <Card
            icon={Users}
            title="Local-first employment"
            desc="We hire locally and source locally where possible, keeping value within the community."
          />
          <Card
            icon={Leaf}
            title="Nature-led experiences"
            desc="We don’t force the forest to perform — seasonality and weather are part of the story."
          />
        </div>
      </Section>
    </div>
  );
};

export default Sustainability;
